const FETCH_PARTNERS = 'partners/FETCH_PARTNERS';
const FETCH_PARTNERS_SUCCESS = 'partners/FETCH_PARTNERS_SUCCESS';
const FETCH_PARTNERS_FAILURE = 'partners/FETCH_PARTNERS_FAILURE';

export default {
  FETCH_PARTNERS,
  FETCH_PARTNERS_SUCCESS,
  FETCH_PARTNERS_FAILURE,
};
